// @flow
import React, { Component } from "react";
import { Button, Form, Icon, Grid } from "tabler-react";
import Select from "react-select";

class UnidadElementosForm extends Component {
  constructor(props) {
    super(props);
    this.state = {
      //Llava Primaria
      id: 0,
      //Campos
      nombre: "",
      placa: "",
      color: "",
      modelo: "",
      estatus: 0,
      //Variables
      accion: this.props.accion, //'nuevo'// modificar, nuevo
      UnidadMarca: { value: "id", label: "Selecciona una Unidad Marca " },
      Estatus: { value: "id", label: "Selecciona un Estatus " },
      crudbutonEnable: true, // Se desabilita cuando se hace click
    };
    this.UnidadesObj = {
      id: 0,
      nombre: "",
      placa: "",
      color: "",
      modelo: "",
      estatus: 0,
      unidadMarca: { id: "", nombre: "" },
    };
    this.enableSave = this.enableSave.bind(this);
    this.UnidadMarca = [];
    this.Estatus = [];
  }
  isEnable = (Accion) => {
    let borrar = "unidad_elemento_borrar";
    let actualizar = "unidad_elemento_editar";
    let agregar = "unidad_elemento_agregar";
    var privilegios = this.props.stor.privilegios_object;
    var perfil = JSON.parse(sessionStorage.getItem("perfil"));
    for (let i = 0; i < privilegios.length; i++) {
      if (Accion === "borrar") {
        if (privilegios[i].clave == borrar) {
          if (
            perfil.privilegios.filter(
              (word) => word.idPrivilegio == privilegios[i].id
            ).length > 0
          ) {
            return true;
          }
        }
      }
      if (Accion === "actualizar") {
        if (privilegios[i].clave == actualizar) {
          if (
            perfil.privilegios.filter(
              (word) => word.idPrivilegio == privilegios[i].id
            ).length > 0
          ) {
            return true;
          }
        }
      }
      if (Accion === "agregar") {
        if (privilegios[i].clave == agregar) {
          if (
            perfil.privilegios.filter(
              (word) => word.idPrivilegio == privilegios[i].id
            ).length > 0
          ) {
            return true;
          }
        }
      }
    }
    return false;
  };

  componentDidMount = () => {
    this.Estatus.push({ value: 0, label: "Disponible" });
    this.Estatus.push({ value: 1, label: "Asignado" });
    this.props.stor.unidadesmarcas_object.map((elemento, index) => {
      this.UnidadMarca.push({ value: elemento.id, label: elemento.nombre });
    });

    if (this.state.accion === "nuevo") {
    } else {
      console.log("34 this.props.elementos");
      console.log(this.props.elementos);
      this.setState({ id: this.props.elementos.id });
      this.setState({ nombre: this.props.elementos.nombre });
      this.setState({ placa: this.props.elementos.placa });
      this.setState({ color: this.props.elementos.color });
      this.setState({ modelo: this.props.elementos.modelo });
      this.setState({ estatus: this.props.elementos.estatus });
      this.setState({ UnidadMarca: this.props.elementos.unidadMarca.id });
      this.UnidadesObj = this.props.elementos;
      //this.UnidadesObj.unidadMarca.id     = this.props.elementos.unidadMarca.id;
      //this.UnidadesObj.unidadMarca.nombre = this.props.elementos.unidadMarca.nombre;
      for (let item of this.props.stor.unidadesmarcas_object) {
        if (item.id === this.props.elementos.unidadMarca.id) {
          this.setState({
            UnidadMarca: {
              value: this.props.elementos.unidadMarca.id,
              label: this.props.elementos.unidadMarca.nombre,
            },
          });
          break;
        }
      }
      if (this.props.elementos.estatus === 0) {
        this.setState({ value: 0, label: "Disponible" });
        this.setState({ estatus: 0 });
        this.setState({ Estatus: { value: 0, label: "Disponible" } });
        this.UnidadesObj.estatus = 0;
      } else {
        this.setState({ value: 1, label: "Asignado" });
        this.setState({ estatus: 1 });
        this.setState({ Estatus: { value: 1, label: "Asignado" } });
        this.UnidadesObj.estatus = 1;
      }
    }
  };

  enableSave = () => {
    console.log("Enable button: " + this.state.nombre);
    if (this.state.nombre.length > 0) {
      return false;
    } else {
      return true;
    }
  };

  changeName = (event) => {
    this.setState({ nombre: event.target.value });
    this.UnidadesObj.nombre = event.target.value;
  };
  changePlaca = (event) => {
    this.setState({ placa: event.target.value });
    this.UnidadesObj.placa = event.target.value;
  };
  changeColor = (event) => {
    this.setState({ color: event.target.value });
    this.UnidadesObj.color = event.target.value;
  };
  changeModelo = (event) => {
    this.setState({ modelo: event.target.value });
    this.UnidadesObj.modelo = event.target.value;
  };
  changeEstatus = (event) => {
    console.log("105 event.value");
    console.log(event.value);
    this.setState({ Estatus: event });
    this.setState({ Estatus: { value: event.value, label: event.label } });
    this.setState({ estatus: event.value });
    this.UnidadesObj.estatus = event.value;
  };
  //changeEstatus = (event) => {
  //  this.state.estatus === 0 ? this.setState({ estatus: 1 }) : this.setState({ estatus: 0 });
  //  this.state.estatus === 0 ? this.UnidadesObj.estatus = 1 : this.UnidadesObj.estatus = 0;
  //}
  changeUnidadMarca = (event) => {
    this.setState({ unidadMarca: event });
    this.setState({ UnidadMarca: { value: event.value, label: event.label } });
    //console.log(this.UnidadesObj)
    this.UnidadesObj.unidadMarca.id = event.value;
    this.UnidadesObj.unidadMarca.nombre = event.label;

    //UnidadesObj

    for (let item of this.props.stor.unidadesmarcas_object) {
      console.log("item: " + item.id + " target: " + event.value);
      if (item.id === event.value) {
        this.setState({
          UnidadMarca: { value: event.value, label: event.label },
        });
        break;
      }
    }
  };
  guardarUnidad = () => {
    if (this.state.accion === "modificar") this.crud_put();
    else this.crud_post();
    this.props.cerrarModal();
  };
  delete() {
    this.setState({ crudbutonEnable: false });
    this.props.getfuntion("delete", "", this.state.id);
  }
  crud_put() {
    this.setState({ crudbutonEnable: false });
    this.props.getfuntion(
      "put",
      this.UnidadesObj,
      "",
      "unidadElementos",
      "unidadElementos"
    );
  }
  crud_post() {
    this.setState({ crudbutonEnable: false });
    this.props.getfuntion(
      "post",
      this.UnidadesObj,
      "",
      "unidadElementos",
      "unidadElementos"
    );
  }
  render() {
    return (
      <div>
        {this.state.accion === "modificar" ? (
          <h1>{this.props.elementos.nombre}</h1>
        ) : null}
        <Grid.Row>
          <Grid.Col md={12} xl={12}>
            <Grid.Row>
              <Grid.Col md={3} lg={3}>
                <Form.Group label="id">
                  <Form.Input
                    name="id"
                    disabled
                    type="number"
                    value={this.state.id}
                  />
                </Form.Group>
              </Grid.Col>
              <Grid.Col md={9} lg={9}>
                <Form.Group label="Nombre">
                  <Form.Input
                    name="nombre"
                    type="text"
                    value={this.state.nombre}
                    onChange={this.changeName}
                    maxlength="30"
                  />
                </Form.Group>
              </Grid.Col>
            </Grid.Row>

            <Grid.Row>
              <Grid.Col md={4} lg={4}>
                <Form.Group label="Placa">
                  <Form.Input
                    name="placa"
                    type="text"
                    value={this.state.placa}
                    onChange={this.changePlaca}
                    maxlength="30"
                  />
                </Form.Group>
              </Grid.Col>
              <Grid.Col md={4} lg={4}>
                <Form.Group label="Color">
                  <Form.Input
                    name="color"
                    type="text"
                    value={this.state.color}
                    onChange={this.changeColor}
                    maxlength="30"
                  />
                </Form.Group>
              </Grid.Col>
              <Grid.Col md={4} lg={4}>
                <Form.Group label="Modelo">
                  <Form.Input
                    name="modelo"
                    type="text"
                    value={this.state.modelo}
                    onChange={this.changeModelo}
                    maxlength="30"
                  />
                </Form.Group>
              </Grid.Col>
            </Grid.Row>

            <Grid.Col md={12} lg={12}>
              <Form.Group label="Marca de Unidad">
                <Select
                  value={this.state.UnidadMarca}
                  onChange={this.changeUnidadMarca}
                  options={this.UnidadMarca}
                />
              </Form.Group>
            </Grid.Col>

            <Grid.Col md={12} lg={12}>
              <Form.Group label="Estatus">
                <Select
                  value={this.state.Estatus}
                  onChange={this.changeEstatus}
                  options={this.Estatus}
                />
              </Form.Group>
            </Grid.Col>
          </Grid.Col>
        </Grid.Row>
        <div className="float-right">
          {this.isEnable("actualizar" || this.isEnable("agregar")) ? (
            <span class="badge">
              <Button
                target="_blank"
                size="sm"
                RootComponent="a"
                color="primary"
                disabled={this.enableSave() || !this.state.crudbutonEnable}
                onClick={this.guardarUnidad}
              >
                <span class="badge">
                  <Icon link={true} name="save" />
                  Guardar
                </span>
              </Button>
            </span>
          ) : null}
          {this.state.accion === "modificar" && this.isEnable("borrar") ? (
            <span class="badge">
              <Button
                target="_blank"
                size="sm"
                RootComponent="a"
                color="primary"
                onClick={() => this.delete()}
                disabled={!this.state.crudbutonEnable}
              >
                <span class="badge">
                  <Icon link={true} name="trash" />
                  Borrar
                </span>
              </Button>
            </span>
          ) : null}
        </div>
      </div>
    );
  }
}
export default UnidadElementosForm;
